<div class="view-request-container">
  <div class="view-request-header">
    <button (click)="router.navigate(['/cargo-owner/dashboard/requests'])" class="btn btn-back">
      ← {{ backText }}
    </button>
    <h1>{{ titleText }} {{ requestId | docNo:'R':request?.createdAt }}</h1>
    <div class="header-actions">
      <button 
        *ngIf="requestId && !hasBids" 
        (click)="editRequest()" 
        class="btn btn-primary"
      >
        {{ editRequestText }}
      </button>
      <button 
        *ngIf="canDeleteRequest()" 
        (click)="deleteRequest()" 
        class="btn btn-danger"
        [disabled]="deletingRequest"
      >
        {{ deletingRequest ? deletingRequestText : deleteRequestText }}
      </button>
      <span *ngIf="hasBids" class="edit-disabled-message">
        {{ editDisabledText }}
      </span>
      <button *ngIf="requestId" type="button" class="btn btn-chat" (click)="scrollToChat()">
        💬 {{ chatButtonText }}
      </button>
    </div>
  </div>

  <div class="view-request-assign" *ngIf="request && companyContext.company && (companyContext.hasPermission('ASSIGN_REQUESTS') || request.assignedManagerName)">
    <app-assignee-select kind="manager" [entityId]="request.id" [currentId]="request.assignedManagerId"
                         [currentName]="request.assignedManagerName"
                         [canEdit]="companyContext.hasPermission('ASSIGN_REQUESTS')"
                         (assigned)="onManagerAssigned($event)"></app-assignee-select>
  </div>

  <div class="view-request-content">
    <app-view-request-base *ngIf="requestId" [requestId]="requestId"></app-view-request-base>

    <app-request-bids-section *ngIf="requestId" [cargoRequestId]="requestId" bidViewRoutePrefix="cargo-owner" (bidsLoaded)="hasBids = $event > 0"></app-request-bids-section>

    <!-- Секция товаров для расчета таможенных платежей -->
    <div class="customs-products-section" *ngIf="request?.calculateCustomsPayments">
      <h2>{{ customsProductsSectionTitleText }}</h2>

      <div *ngIf="request?.customsProducts && (request?.customsProducts?.length ?? 0) > 0" class="customs-products-list">
        <!-- Бейдж "Выполнено с помощью AI" -->
        <div *ngIf="request?.customsCalculationCompletedWithAi" class="calculation-status ai-completed">
          <span class="status-icon">🤖</span>
          <span>{{ completedWithAiText }}</span>
        </div>
        <div *ngIf="request?.customsCalculationCompleted && !request?.customsCalculationCompletedWithAi" class="calculation-status completed">
          <span class="status-icon">✓</span>
          <span>{{ calculationCompletedText }}</span>
          <span *ngIf="request?.customsCalculationCompletedAt" class="completion-date">
            {{ request?.customsCalculationCompletedAt | date:'short' }}
          </span>
        </div>
        <div *ngIf="request?.customsCalculationStarted && !request?.customsCalculationCompleted && !request?.customsCalculationCompletedWithAi" class="calculation-status in-progress">
          <span class="status-icon">🔄</span>
          <span>{{ calculationInProgressText }}</span>
        </div>
        <!-- Показываем "Ожидает расчета брокером" только если расчет не выполнен AI и не начат брокером -->
        <div *ngIf="!request?.customsCalculationStarted && !request?.customsCalculationCompleted && !request?.customsCalculationCompletedWithAi" class="calculation-status pending">
          <span class="status-icon">⏳</span>
          <span>{{ calculationPendingText }}</span>
        </div>

        <!-- Кнопка редактирования товаров (только если брокер еще не начал работу и AI не выполнен) -->
        <div *ngIf="!request?.customsCalculationStarted && !request?.customsCalculationCompleted && !request?.customsCalculationCompletedWithAi" class="edit-customs-products-actions">
          <button (click)="editCustomsProducts()" class="btn btn-primary">
            {{ editCustomsProductsText }}
          </button>
        </div>

        <!-- Инвойс -->
        <div class="invoice-section">
          <h3>{{ invoiceText }}</h3>
          <div *ngIf="loadingInvoice" class="loading-invoice">
            {{ loadingText }}
          </div>
          <div *ngIf="!loadingInvoice && invoiceFile" class="invoice-file">
            <a href="#" (click)="downloadInvoice($event)" class="invoice-download-link">
              📄 {{ invoiceFile.fileName }}
            </a>
            <span class="invoice-size">({{ (invoiceFile.fileSize / 1024).toFixed(1) }} KB)</span>
          </div>
          <div *ngIf="!loadingInvoice && !invoiceFile" class="no-invoice">
            {{ noInvoiceText }}
          </div>
        </div>

        <table class="customs-products-table">
          <thead>
            <tr>
              <th>{{ productNameText }}</th>
              <th>{{ productTnvedText }}</th>
              <th>{{ productCostText }}</th>
              <th *ngIf="hasCalculationResults()">{{ customsFeesText }}</th>
              <th *ngIf="hasCalculationResults()">{{ customsDutyText }}</th>
              <th *ngIf="hasCalculationResults()">{{ vatText }}</th>
              <th *ngIf="hasCalculationResults()">{{ totalPaymentsText }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of request?.customsProducts || []">
              <td>
                <!-- Показываем данные AI/брокера, если они есть -->
                <span *ngIf="product.nameForBroker">
                  {{ product.nameForBroker }}
                </span>
                <!-- До расчета показываем исходные данные грузовладельца -->
                <span *ngIf="!product.nameForBroker">
                  {{ product.nameOriginal }}
                </span>
              </td>
              <td>
                <!-- Показываем данные AI/брокера, если они есть -->
                <span *ngIf="product.tnvedCodeForBroker">
                  {{ product.tnvedCodeForBroker }}
                  <span *ngIf="product.tnvedCodeInDictionary" class="badge badge-success" style="margin-left: 0.5rem; font-size: 0.75rem;">{{ inDictionaryBadgeText }}</span>
                  <span *ngIf="product.tnvedCodeInDictionary === false" class="badge badge-warning" style="margin-left: 0.5rem; font-size: 0.75rem;">{{ codeNotFoundText }}</span>
                </span>
                <!-- До расчета показываем исходные данные грузовладельца -->
                <span *ngIf="!product.tnvedCodeForBroker">
                  {{ product.tnvedCodeOriginal || '-' }}
                </span>
              </td>
              <td>{{ product.productCost | number:'1.2-2' }}</td>
              <!-- Поля платежей показываем, если есть данные от AI или брокера -->
              <td *ngIf="hasCalculationResults()">
                {{ product.customsFees != null ? (product.customsFees | number:'1.2-2') : '-' }}
              </td>
              <td *ngIf="hasCalculationResults()">
                {{ product.customsDuty != null ? (product.customsDuty | number:'1.2-2') : '0.00' }}
              </td>
              <td *ngIf="hasCalculationResults()">
                {{ product.vat != null ? (product.vat | number:'1.2-2') : '-' }}
              </td>
              <td *ngIf="hasCalculationResults()" class="total-payments">
                {{ product.totalCustomsPayments ? (product.totalCustomsPayments | number:'1.2-2') : '-' }}
              </td>
            </tr>
          </tbody>
          <tfoot *ngIf="hasCalculationResults()">
            <tr>
              <td colspan="4" class="total-label">{{ totalAllPaymentsText }}:</td>
              <td class="total-amount" colspan="3">
                {{ getTotalCustomsPayments() | number:'1.2-2' }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div *ngIf="!request?.customsProducts || request?.customsProducts?.length === 0" class="no-customs-products">
        {{ noCustomsProductsText }}
      </div>
    </div>
  </div>

  <div class="request-chat" id="chat" *ngIf="requestId">
    <app-chat-threads [requestId]="requestId" [locked]="!!request?.hasDeal" [initialForwarderId]="chatForwarderId"></app-chat-threads>
  </div>
</div>
